import * as React from 'react';

import { Button, Icon, Dropdown, Menu, MenuItem } from 'components';

import { AuthContext } from 'contexts';
import { useHistory } from 'react-router-dom';
import Searchbar from './Searchbar';
import ManageUsersContext from '../ManageUsersContext';
import { StyledHeaderActions } from '../StyledComponents';

const UsersHeader: React.FC<{ md: boolean }> = ({ md }) => {
  const {
    setSearchText,
    searchText,
    locations,
    roleFilters,
    statusFilters,
    selectedUsers,
  } = React.useContext(ManageUsersContext); // Adding for view activity button (selectedUsers)

  const { auth } = React.useContext(AuthContext);

  const constructCsvUrl = () => {
    const basePath = '/user/org/csv';
    const params = {
      locations: locations.join(','),
      roles: roleFilters,
      statuses: statusFilters,
      searchText,
    };
    const url = `${basePath}?${Object.entries(params)
      .filter(([_, value]) => value)
      .map(([key, value]) => `${key}=${value}`)
      .join('&')}`;
    return url;
  };

  const textChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  };

  const history = useHistory();
  const handleActivityClickBtn = () => {
    const query = selectedUsers.reduce((acc, user) => `${acc}${user},`, '');
    history.push(`/lockboxesActivities?userIds=${query}`);
  };

  return (
    <StyledHeaderActions wrap $md={md}>
      <Button disabled={!selectedUsers.length} onClick={handleActivityClickBtn}>
        View Activities
      </Button>
      <Searchbar
        allowClear
        placeholder="Search Users"
        value={searchText}
        onChange={textChangeHandler}
        suffix={<Icon type="search" color="gray5" />}
        data-cy="user-search-input"
      />

      <Button
        href="#/users/new/"
        type="primary"
        icon={
          <Icon
            type="plus"
            color="white"
            width={20}
            height={20}
            offset={[0, 2]}
          />
        }
        data-cy="add-user-button"
      >
        Add User
      </Button>

      <Dropdown
        trigger={['click']}
        dropdownRender={() => (
          <Menu>
            <MenuItem
              key={'export'}
              href={constructCsvUrl()}
              data-cy="user-search-export"
            >
              Export CSV
            </MenuItem>
          </Menu>
        )}
        data-cy="user-search-menu"
      >
        <Button type="text" data-cy="user-ellipsis-button">
          <Icon type="ellipsis" width={25} />
        </Button>
      </Dropdown>
    </StyledHeaderActions>
  );
};

export default UsersHeader;
